import React, { useState, useRef } from "react";
import { uploadLogo } from "../api/uploadService";

export default function LogoUploader({ onUpload }) {
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState("");
  const [dragActive, setDragActive] = useState(false);

  const inputRef = useRef(null);

  // ─────────────────────────────
  // Upload handler
  // ─────────────────────────────
  const handleFile = async (file) => {
    console.log("FILE:", file);
    if (!file) return;

    setPreview(URL.createObjectURL(file));
    setLoading(true);

    try {
      const url = await uploadLogo(file);
      onUpload(url);
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    }

    setLoading(false);
  };

  // ─────────────────────────────
  // Drag Events
  // ─────────────────────────────
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    handleFile(file);
  };

  return (
    <div style={{ marginBottom: 20 }}>
      <label style={{ fontWeight: 600, fontSize: 13 }}>
        Business Logo
      </label>

      {/* DRAG DROP AREA */}
      <div
        onClick={() => inputRef.current.click()}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        style={{
          marginTop: 10,
          padding: 20,
          borderRadius: 12,
          border: dragActive
            ? "2px dashed #2d2b69"
            : "2px dashed #ccc",
          background: dragActive ? "#f3f3ff" : "#fafafa",
          textAlign: "center",
          cursor: "pointer",
          transition: "0.2s",
        }}
      >
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          onChange={handleChange}
          style={{ display: "none" }}
        />

        {preview ? (
          <img
            src={preview}
            alt="preview"
            style={{
              width: 90,
              height: 90,
              borderRadius: 12,
              objectFit: "cover",
            }}
          />
        ) : (
          <p style={{ margin: 0, color: "#666" }}>
            Drag & Drop logo here or click to upload
          </p>
        )}
      </div>

      {loading && (
        <p style={{ fontSize: 12, marginTop: 8 }}>
          Uploading...
        </p>
      )}
    </div>
  );
}